import Card from "../components/UI/Card";
import Logo from "../components/Logo";
import MenuList from "../components/Menu/MenuList";
import MenuItem from "../components/Menu/MenuItem";

import { useNavigate } from "react-router-dom";

import logoImage from "../images/logo.png";

const Homepage = ({ menuItems }) => {
  const navigate = useNavigate();

  return (
    <Card>
      <Logo image={logoImage} imageAlt={"Logo"} />
      <MenuList>
        {menuItems.map((item) => (
          <MenuItem
            onClick={() => navigate(item.route)}
            key={item.id}
            image={item.image}
            name={item.name}
          />
        ))}
      </MenuList>
    </Card>
  );
};

export default Homepage;
